module.exports = __webpack_public_path__ + "img/navbarLogo.2363acb9.png";